import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CustomerReportsLayer from "../components/CustomerReportsLayer";

const CustomerReportsPage = () => {
    return (
        <MasterLayout>
            <CustomerReportsLayer />
        </MasterLayout>
    );
};

export default CustomerReportsPage;
